import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import SectionTitle from "@/components/base/SectionTitle";
import { company } from "@/mocks/company";

export default function Company() {
  const infoRows = [
    { label: "会社名", value: `${company.name}（${company.nameEn}）` },
    { label: "代表者", value: company.representative },
    { label: "設立", value: company.founded },
    { label: "資本金", value: company.capital },
    { label: "従業員数", value: company.employees },
    { label: "所在地", value: company.address },
    { label: "電話番号", value: company.phone },
    { label: "メール", value: company.email },
    { label: "営業時間", value: company.hours },
  ];

  return (
    <Layout>
      <PageHero
        eyebrow="Corporate Information"
        title="会社概要"
        description="株式会社DAISANの基本情報について。"
        image="images/company.avif"
      />
      <section className="bg-background-50 py-20 md:py-28">
        <div className="mx-auto max-w-5xl px-4 md:px-10">
          <SectionTitle eyebrow="Company Profile" title="会社概要" />
          <div className="bg-background-100 border border-background-200 rounded-lg overflow-hidden">
            <table className="w-full text-sm md:text-base">
              <tbody>
                {infoRows.map((row) => (
                  <tr key={row.label} className="border-b border-background-200 last:border-b-0">
                    <th className="text-left align-top w-36 md:w-52 bg-primary-50 text-primary-800 font-medium px-5 md:px-6 py-4 whitespace-nowrap">
                      {row.label}
                    </th>
                    <td className="px-5 md:px-6 py-4 text-foreground-800 leading-relaxed">
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-20 md:py-28">
        <div className="mx-auto max-w-6xl px-4 md:px-10">
          <SectionTitle eyebrow="Access" title="所在地・アクセス" />
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 items-stretch">
            <div className="md:col-span-2 bg-background-100 border border-background-200 rounded-lg p-7">
              <h3 className="font-heading text-lg text-foreground-950 mb-3">本社</h3>
              <p className="text-sm text-foreground-800 leading-relaxed mb-4">
                {company.address}
              </p>
              <ul className="space-y-2 text-sm text-foreground-700">
                <li className="flex items-center gap-2"><i className="ri-phone-line"></i>{company.phone}</li>
                <li className="flex items-center gap-2"><i className="ri-mail-line"></i>{company.email}</li>
                <li className="flex items-center gap-2"><i className="ri-time-line"></i>{company.hours}</li>
                <li className="flex items-center gap-2"><i className="ri-train-line"></i>鹿児島本線 千早駅 徒歩10分</li>
              </ul>
            </div>
            <div className="md:col-span-3 h-72 md:h-96 rounded-lg overflow-hidden border border-background-200">
              <iframe
                title="daisan-office-map"
                src="https://www.google.com/maps?q=福岡市東区松崎4丁目20-26-1&output=embed"
                className="w-full h-full"
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}